var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoftwareDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 543,
    height: 331,
    viewBox: "0 0 543 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1104_235763)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 543,
    height: 331,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.771 288.655C486.539 292.35 480.407 206.806 465.175 175.112C465.161 175.154 420.397 75.5647 365.023 60.5664C299.571 42.8386 263.461 105.723 306.041 152.307C357.073 208.137 252.415 283.502 388.771 288.655Z",
    fill: "#E0ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.167 103.241C446.19 122.45 459.067 118.95 467.186 114.192C496.598 96.9526 473.946 31.8596 428.026 23.1698C382.106 14.4801 377.037 53.0121 400.961 61.3603C414.265 66.0027 431.58 87.4719 438.167 103.241Z",
    fill: "#FFF6E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M80.1791 272.904C23.0736 275.506 9.41117 169.383 26.8399 149.399C49.9726 122.876 82.9547 113.219 91.2143 83.0737C101.672 44.9066 141.719 -0.205396 215.289 19.8503C316.469 47.4323 387.051 128.12 331.293 159.943C275.536 191.766 323.551 195.521 305.954 259.758C288.357 323.995 211.318 335.76 180.887 282.442C150.455 229.123 141.495 270.11 80.1791 272.904Z",
    fill: "#E0FFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.635 234V247.27",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.27 240.635L375.999 240.635",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6309 114V127.27",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2695 120.635L21.9994 120.635",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6309 220V233.27",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2695 226.635L68.9994 226.635",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.631 293V306.27",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.27 299.635L288.999 299.635",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1104_235763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.543 247.993C427.962 247.894 427.365 247.992 426.846 248.271C426.326 248.549 425.915 248.994 425.678 249.533L420.945 260.274C420.708 260.813 420.657 261.417 420.802 261.988C420.946 262.559 421.277 263.066 421.743 263.428L427.436 267.842C427.715 268.06 427.949 268.331 428.122 268.641C428.294 268.95 428.403 269.291 428.442 269.643L428.873 273.563C428.911 273.916 428.878 274.273 428.776 274.613C428.673 274.953 428.503 275.268 428.276 275.541L423.669 281.08C423.291 281.534 423.076 282.1 423.058 282.69C423.04 283.28 423.22 283.859 423.569 284.335L430.503 293.8C430.852 294.276 431.349 294.621 431.916 294.782C432.484 294.942 433.088 294.908 433.634 294.686L440.308 291.964C440.636 291.83 440.988 291.764 441.343 291.768C441.697 291.773 442.047 291.85 442.372 291.993L445.977 293.581C446.302 293.724 446.595 293.93 446.838 294.189C447.082 294.448 447.27 294.753 447.393 295.086L449.886 301.846C450.091 302.4 450.474 302.869 450.976 303.179C451.478 303.489 452.07 303.623 452.656 303.558L464.317 302.288C464.903 302.224 465.451 301.966 465.873 301.555C466.295 301.144 466.568 300.603 466.648 300.019L467.626 292.91C467.675 292.55 467.798 292.203 467.988 291.893C468.178 291.582 468.429 291.314 468.727 291.105L471.166 289.398C471.681 289.038 472.306 288.874 472.931 288.933L481.116 289.697C481.669 289.748 482.223 289.624 482.701 289.343C483.179 289.061 483.557 288.637 483.78 288.129L488.638 277.103C488.862 276.595 488.921 276.029 488.805 275.486C488.69 274.943 488.406 274.451 487.995 274.078L481.912 268.561C481.444 268.137 481.144 267.558 481.065 266.931L480.692 263.93C480.647 263.57 480.676 263.205 480.778 262.858C480.88 262.51 481.052 262.187 481.284 261.909L485.847 256.437C486.225 255.984 486.44 255.418 486.459 254.828C486.477 254.238 486.298 253.659 485.949 253.183L479.009 243.707C478.662 243.234 478.168 242.889 477.605 242.728C477.041 242.566 476.439 242.597 475.895 242.814L469.248 245.47C468.922 245.6 468.573 245.664 468.222 245.658C467.871 245.652 467.525 245.577 467.203 245.435L463.575 243.837C463.254 243.695 462.964 243.49 462.723 243.235C462.481 242.98 462.293 242.68 462.17 242.351L459.643 235.654C459.436 235.105 459.053 234.641 458.553 234.334C458.054 234.027 457.466 233.895 456.883 233.958L445.206 235.232C444.62 235.297 444.072 235.556 443.65 235.967C443.228 236.379 442.955 236.92 442.876 237.505L441.912 244.591C441.865 244.942 441.747 245.279 441.567 245.584C441.387 245.888 441.147 246.154 440.862 246.364L437.651 248.734C437.365 248.946 437.039 249.097 436.692 249.18C436.345 249.263 435.986 249.274 435.634 249.214L428.544 247.997L428.543 247.993Z",
    stroke: "#18181A",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.09 256.664C463.298 258.077 465.813 260.707 467.082 263.975C468.351 267.243 468.27 270.881 466.857 274.089C465.443 277.297 462.813 279.812 459.545 281.081C456.278 282.35 452.64 282.269 449.432 280.855C446.224 279.442 443.709 276.812 442.44 273.544C441.171 270.276 441.252 266.638 442.665 263.43C444.079 260.222 446.708 257.707 449.976 256.438C453.244 255.169 456.882 255.251 460.09 256.664Z",
    stroke: "#18181A",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1104_235763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3443 9.12808C82.8202 8.38743 82.0636 7.84315 81.1947 7.5817C80.3258 7.32025 79.3945 7.35663 78.5487 7.68506L61.7027 14.2267C60.8569 14.5551 60.1451 15.1568 59.6803 15.9361C59.2156 16.7154 59.0246 17.6277 59.1377 18.528L60.5291 29.5321C60.5971 30.0735 60.5555 30.6231 60.4068 31.1481C60.2582 31.6731 60.0054 32.1629 59.6637 32.5883L55.8661 37.3246C55.5236 37.7507 55.0988 38.1035 54.617 38.3619C54.1351 38.6202 53.6062 38.7789 53.0618 38.8284L42.0161 39.8429C41.1112 39.9257 40.2601 40.3089 39.5982 40.9314C38.9363 41.554 38.5018 42.3802 38.3639 43.2783L35.6082 61.1323C35.4696 62.0295 35.635 62.9473 36.078 63.7396C36.521 64.532 37.2162 65.1536 38.053 65.5055L48.2815 69.8076C48.7849 70.0193 49.2406 70.3301 49.6214 70.7216C50.0022 71.1131 50.3003 71.5772 50.498 72.0862L52.6933 77.7395C52.8917 78.249 52.9855 78.7933 52.9689 79.3399C52.9523 79.8865 52.8258 80.4241 52.5969 80.9207L47.9509 90.9945C47.5708 91.8197 47.4778 92.7484 47.6867 93.6327C47.8955 94.5169 48.3942 95.3058 49.1033 95.8738L63.1808 107.187C63.8885 107.755 64.7658 108.07 65.6732 108.082C66.5807 108.095 67.4662 107.803 68.1891 107.255L76.9927 100.579C77.4391 100.24 77.9506 99.9975 78.4952 99.8656C79.0398 99.7338 79.6057 99.7158 80.1576 99.8128L84.6718 100.61C85.6232 100.779 86.4835 101.28 87.0989 102.025L95.1787 111.768C95.7243 112.425 96.4628 112.894 97.2896 113.108C98.1164 113.322 98.9896 113.271 99.7856 112.961L117.079 106.246C117.876 105.937 118.555 105.385 119.021 104.668C119.486 103.951 119.714 103.106 119.672 102.252L119.056 89.6243C119.008 88.6522 119.311 87.6953 119.908 86.9269L122.769 83.253C123.111 82.8126 123.541 82.4474 124.03 82.18C124.52 81.9125 125.059 81.7485 125.615 81.6982L136.539 80.7089C137.444 80.6266 138.295 80.2441 138.957 79.6223C139.619 79.0004 140.054 78.1749 140.193 77.2773L142.954 59.4037C143.092 58.5114 142.929 57.5987 142.491 56.8091C142.053 56.0195 141.365 55.398 140.535 55.0421L130.408 50.6964C129.911 50.4834 129.462 50.1736 129.086 49.785C128.71 49.3964 128.415 48.9369 128.219 48.4332L126.009 42.742C125.814 42.2378 125.721 41.6999 125.736 41.1595C125.752 40.6192 125.874 40.0872 126.097 39.5948L130.638 29.5531C131.01 28.7306 131.098 27.8076 130.888 26.9295C130.678 26.0514 130.183 25.2679 129.479 24.7024L115.379 13.3763C114.67 12.8085 113.792 12.4938 112.884 12.4825C111.976 12.4711 111.091 12.7636 110.368 13.3136L101.604 19.9785C101.17 20.3089 100.675 20.5488 100.147 20.6841C99.6191 20.8194 99.0693 20.8472 98.5303 20.766L92.455 19.8505C91.9124 19.7693 91.3918 19.5792 90.9245 19.2917C90.4572 19.0042 90.0528 18.6252 89.7357 18.1775L83.342 9.13335L83.3443 9.12808Z",
    stroke: "black",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25 52.9131C110.203 57.9445 110.078 63.5459 107.902 68.4851C105.726 73.4243 101.677 77.2967 96.6455 79.2505C91.6141 81.2043 86.0127 81.0793 81.0735 78.9031C76.1343 76.727 72.2619 72.6778 70.3081 67.6465C68.3543 62.6151 68.4793 57.0137 70.6554 52.0745C72.8316 47.1353 76.8808 43.2629 81.9121 41.3091C86.9435 39.3553 92.5449 39.4803 97.4841 41.6565C102.423 43.8326 106.296 47.8818 108.25 52.9131Z",
    fill: "white",
    stroke: "#18181A",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 161.5,
    y: 11.5,
    width: 262,
    height: 206,
    rx: 7.5,
    fill: "#18181A",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5 217.5V45.5H231.5V217.5H161.5Z",
    fill: "#18181A",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5 43V43.5H161H424H424.5V43V18C424.5 13.3056 420.694 9.5 416 9.5H169C164.306 9.5 160.5 13.3056 160.5 18V43Z",
    fill: "#18181A",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5 43.5V218",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.191,
    cy: 26.9599,
    r: 4.95694,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.105,
    cy: 26.9599,
    r: 4.95694,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.019,
    cy: 26.9599,
    r: 4.95694,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.164,
    y: 271.164,
    width: 61.6727,
    height: 23.6727,
    rx: 3.83637,
    fill: "#18181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.961 277.185H342.421V289.004H339.961V284.102H334.173V289.004H331.713V277.185H334.173V282.087H339.961V277.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.413 277.185H354.543V279.199H350.708V289.004H348.248V279.199H344.413V277.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.54 289.004V277.185H360.809L363.45 286.116C363.54 286.418 363.558 286.855 363.558 287.258C363.558 287.392 363.631 287.459 363.775 287.459C363.92 287.459 363.992 287.392 363.992 287.258C363.992 286.855 364.011 286.418 364.101 286.116L366.742 277.185H371.011V289.004H368.551V280.156C368.551 279.619 368.696 279.199 368.858 278.746C368.913 278.595 368.858 278.494 368.696 278.461C368.605 278.444 368.515 278.494 368.478 278.612L365.295 289.004H362.256L359.072 278.612C359.036 278.494 358.946 278.444 358.855 278.461C358.692 278.494 358.638 278.595 358.692 278.746C358.855 279.199 359 279.619 359 280.156V289.004H356.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.581 277.185H376.042V286.989H382.264V289.004H373.581V277.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.164,
    y: 271.164,
    width: 61.6727,
    height: 23.6727,
    rx: 3.83637,
    stroke: "black",
    strokeWidth: 0.327251
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.175,
    y: 21.1751,
    width: 50.6498,
    height: 27.6498,
    rx: 2.62613,
    fill: "#18181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.992 35.2977C453.992 31.6549 456.145 28.7078 459.937 28.7078C463.678 28.7078 465.318 31.5451 465.472 33.6868H463.166C463.012 32.4238 462.021 30.9044 459.971 30.9044C457.648 30.9044 456.315 32.8631 456.315 35.2977C456.315 37.7323 457.648 39.691 459.971 39.691C462.021 39.691 463.012 38.1716 463.166 36.9086H465.472C465.318 39.0503 463.678 41.8876 459.937 41.8876C456.145 41.8876 453.992 38.9405 453.992 35.2977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.589 33.8516C474.408 34.1994 476.372 34.9682 476.372 37.8971C476.372 40.0205 474.664 41.8876 471.452 41.8876C468.104 41.8876 466.533 39.5812 466.533 37.2015H468.787C468.822 38.1899 469.249 39.8374 471.452 39.8374C473.451 39.8374 474.049 38.7574 474.049 38.0435C474.049 37.1648 473.519 36.5242 471.452 36.2313C468.036 35.7553 466.943 34.5655 466.943 32.3688C466.943 30.3552 468.634 28.7078 471.486 28.7078C474.613 28.7078 475.894 30.7214 475.928 32.8082H473.724C473.724 31.9661 473.195 30.758 471.452 30.758C469.693 30.758 469.249 31.7098 469.249 32.259C469.249 32.7533 469.471 33.5953 471.589 33.8516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.761 33.8516C485.58 34.1994 487.545 34.9682 487.545 37.8971C487.545 40.0205 485.836 41.8876 482.625 41.8876C479.277 41.8876 477.705 39.5812 477.705 37.2015H479.96C479.994 38.1899 480.421 39.8374 482.625 39.8374C484.623 39.8374 485.221 38.7574 485.221 38.0435C485.221 37.1648 484.692 36.5242 482.625 36.2313C479.208 35.7553 478.115 34.5655 478.115 32.3688C478.115 30.3552 479.806 28.7078 482.659 28.7078C485.785 28.7078 487.066 30.7214 487.1 32.8082H484.897C484.897 31.9661 484.367 30.758 482.625 30.758C480.865 30.758 480.421 31.7098 480.421 32.259C480.421 32.7533 480.643 33.5953 482.761 33.8516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.175,
    y: 21.1751,
    width: 50.6498,
    height: 27.6498,
    rx: 2.62613,
    stroke: "black",
    strokeWidth: 0.350151
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.176,
    y: 137.176,
    width: 35.648,
    height: 25.648,
    rx: 2.63963,
    fill: "#18181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5282 143.388H58.3671V152.487C58.3671 155.612 56.6554 157.471 53.5244 157.471C50.3515 157.471 48.6816 155.612 48.6816 152.487H51.5205C51.5205 154.405 52.4389 155.098 53.5244 155.098C54.3802 155.098 55.5282 154.544 55.5282 152.645V143.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5145 148.788C69.9587 149.164 72.3592 149.995 72.3592 153.159C72.3592 155.454 70.2718 157.471 66.3475 157.471C62.2563 157.471 60.3359 154.979 60.3359 152.408H63.0912C63.133 153.476 63.6548 155.256 66.3475 155.256C68.7898 155.256 69.5204 154.089 69.5204 153.317C69.5204 152.368 68.8733 151.676 66.3475 151.359C62.1728 150.845 60.8369 149.559 60.8369 147.186C60.8369 145.01 62.9034 143.23 66.3893 143.23C70.2092 143.23 71.7747 145.406 71.8165 147.661H69.1238C69.1238 146.751 68.4767 145.445 66.3475 145.445C64.1975 145.445 63.6548 146.474 63.6548 147.067C63.6548 147.601 63.9262 148.511 66.5145 148.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.176,
    y: 137.176,
    width: 35.648,
    height: 25.648,
    rx: 2.63963,
    stroke: "black",
    strokeWidth: 0.351951
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 142.129H486",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 85.1289H462C457.582 85.1289 454 88.7106 454 93.1289V191.129C454 195.547 457.582 199.129 462 199.129H486",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.5,
    y: 68.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.5,
    y: 124.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.5,
    y: 182.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.182 75V93.3648",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.365 84.1826L493 84.1826",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 140L493 140",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.336 194L493.664 194",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.336 201L493.664 201",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.59,
    y: 59,
    width: 31.0247,
    height: 8.98865,
    rx: 4.49433,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.59,
    y: 75.9888,
    width: 48.4213,
    height: 8.98865,
    rx: 4.49433,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.59,
    y: 102.977,
    width: 48.4213,
    height: 3,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.59,
    y: 117.977,
    width: 29.3381,
    height: 3,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.59,
    y: 132.977,
    width: 40.2054,
    height: 3,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.59,
    y: 147.977,
    width: 18.6378,
    height: 3,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.59,
    y: 162.977,
    width: 29.3381,
    height: 3,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.59,
    y: 177.977,
    width: 40.2054,
    height: 3,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.59,
    y: 192.977,
    width: 48,
    height: 3,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.59,
    y: 186.452,
    width: 20.1018,
    height: 2.76274,
    rx: 1.38137,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.3472,
    y: 147.347,
    width: 110.469,
    height: 159.586,
    rx: 5.20822,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.694429
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.4,
    y: 276.771,
    width: 89.5521,
    height: 19.952,
    rx: 9.97601,
    fill: "#11111F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.163 290.716L145.438 288.578H141.289L140.564 290.716H139.087L142.345 281.757H144.381L147.639 290.716H146.163ZM141.658 287.458H145.069L143.592 283.08C143.542 282.915 143.491 282.762 143.465 282.546C143.452 282.47 143.452 282.393 143.363 282.393C143.274 282.393 143.274 282.47 143.262 282.546C143.236 282.762 143.185 282.915 143.134 283.08L141.658 287.458ZM151.659 281.757C154.179 281.757 155.044 282.953 155.044 284.557C155.044 286.16 154.026 287.356 151.863 287.356H149.649V290.716H148.325V281.757H151.659ZM151.85 286.236C153.085 286.236 153.721 285.511 153.721 284.557C153.721 283.5 153.085 282.877 151.85 282.877H149.649V286.236H151.85ZM157.264 290.716H155.94V281.757H157.264V290.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.223,
    y: 180.511,
    width: 17.2889,
    height: 7.1818,
    rx: 3.5909,
    fill: "#11111F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.316,
    y: 209.979,
    width: 22.5046,
    height: 7.1818,
    rx: 3.5909,
    fill: "#11111F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.223,
    y: 224.132,
    width: 71.5536,
    height: 7.1818,
    rx: 3.5909,
    fill: "#11111F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.223,
    y: 239.448,
    width: 38.5953,
    height: 7.1818,
    rx: 3.5909,
    fill: "#11111F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.908,
    y: 180.511,
    width: 48.8712,
    height: 7.1818,
    rx: 3.5909,
    fill: "#11111F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.223,
    y: 195.828,
    width: 52.7482,
    height: 7.1818,
    rx: 3.5909,
    fill: "#11111F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.583 159.657L106.223 166.018L112.583 172.378",
    stroke: "#11111F",
    strokeWidth: 0.694429,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.163 249.4L156.523 243.04L150.163 236.679",
    stroke: "#11111F",
    strokeWidth: 0.694429,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 59.002,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 74.502,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 90.002,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 105.502,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 121.002,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 136.502,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 152.002,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 167.502,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 183.002,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.934,
    y: 59,
    width: 33.2575,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.789,
    y: 88.8169,
    width: 60.781,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.016,
    y: 73.9084,
    width: 63.0746,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.455,
    y: 88.8169,
    width: 17.2022,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.934,
    y: 120.928,
    width: 30.9639,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.016,
    y: 135.837,
    width: 25.2299,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.311,
    y: 151.892,
    width: 43.5788,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.248,
    y: 166.801,
    width: 52.7533,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.311,
    y: 182.856,
    width: 22.9362,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.133,
    y: 182.856,
    width: 38.9916,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.133,
    y: 135.837,
    width: 63.0746,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.635,
    y: 120.928,
    width: 106.653,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.221,
    y: 59,
    width: 103.213,
    height: 6.60926,
    rx: 3.30463,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.148 187.601L382.668 194.081L389.148 200.56",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.921 187.601L410.4 194.081L403.921 200.56",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.292 182.676L393.553 204.707",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0553,
    cy: 199.055,
    r: 4.55529,
    transform: "rotate(-90 28.0553 199.055)",
    stroke: "#18181A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4908,
    cy: 199.055,
    r: 4.55529,
    transform: "rotate(-90 53.4908 199.055)",
    stroke: "#18181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8203 199.054L49.25 199.054",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.054,
    cy: 278.491,
    r: 4.55529,
    transform: "rotate(180 515.054 278.491)",
    stroke: "#18181A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 515.054,
    cy: 253.055,
    r: 4.55529,
    transform: "rotate(180 515.054 253.055)",
    stroke: "#18181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.053 273.727L515.053 257.297",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.183,
    cy: 134.474,
    r: 4.55529,
    transform: "rotate(180 143.183 134.474)",
    stroke: "#18181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.182 129.71L143.182 113.281",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.05529,
    cy: 5.05529,
    r: 4.55529,
    transform: "matrix(1 0 0 -1 69 298.249)",
    stroke: "#18181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0566 288.43L74.0566 272",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.05529,
    cy: 5.05529,
    r: 4.55529,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 317.676 235.55)",
    stroke: "#18181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.494 240.606L343.924 240.606",
    stroke: "#18181A",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.374 286.29C207.191 286.29 211.095 282.385 211.095 277.568C211.095 272.752 207.191 268.847 202.374 268.847C197.557 268.847 193.653 272.752 193.653 277.568C193.653 282.385 197.557 286.29 202.374 286.29Z",
    fill: "white",
    stroke: "#11111F",
    strokeWidth: 0.694429
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.683,
    cy: 215.374,
    r: 8.87404,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.502,
    y: 230.5,
    width: 31.4503,
    height: 31.4503,
    rx: 15.7252,
    fill: "#18181A",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.492 239.492L245.506 252.478",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.492 252.479L245.506 239.493",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.176,
    y: 243.176,
    width: 32.648,
    height: 19.648,
    rx: 2.63963,
    fill: "#18181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4214 248.458L32 253.007L37.4214 257.557",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5767 248.458L52.998 253.007L47.5767 257.557",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3198 245L39.6816 260.468",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.176,
    y: 243.176,
    width: 32.648,
    height: 19.648,
    rx: 2.63963,
    stroke: "black",
    strokeWidth: 0.351951
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1104_235763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 543,
    height: 331,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1104_235763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.593,
    height: 84.593,
    fill: "white",
    transform: "translate(399 290.412) rotate(-66.2221)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1104_235763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130.245,
    height: 130.245,
    fill: "white",
    transform: "translate(5 23.1467) rotate(-21.2221)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/software_development.a39485e7d12cb782853f70e34435629a.svg";
export { ForwardRef as ReactComponent };